import { Builder } from '@builder.io/react'
import dynamic from 'next/dynamic'

import { BLOCK_NAMES } from '@/legacy/blocks/blockNames'

Builder.registerComponent(
  dynamic<never>(() => import('.').then((mod) => mod.BlogIframeBlock)),
  {
    name: BLOCK_NAMES.blog.iframe,
    inputs: [
      {
        name: 'src',
        type: 'string',
        friendlyName: 'URL',
        helperText: 'URL da página que deseja imbutir (iframe)',
        required: true,
      },
      {
        name: 'width',
        type: 'string',
        hideFromUI: true,
      },
      {
        name: 'height',
        type: 'string',
        hideFromUI: true,
      },
    ],
  },
)
